import AccettazioneSsn from "../";

const routes = [

    // { name: "Accettazione Ssn", path: "/accettazionessn/:id", component: AccettazioneSsn.AccettazioneSsnEditViewPage, meta: { title: "Crea/Modifica Accettazione" } },

    { name: "Accettazione Ssn", path: "/nuovaaccettazionessn/:id", component: AccettazioneSsn.AccettazioneSsnEditViewPageN, meta: { title: "Crea Accettazione" } },
    { name: "Elenco Accettazione Ssn", path: "/nuovaaccettazionessn", component: AccettazioneSsn.AccettazioneSsnListPageN, meta: { title: "Elenco Accettazioni" } },
    { name: "Prenotazioni Lazio Recup", path: "/prenotazionilaziorecup", component: AccettazioneSsn.AccettazionePrenotazioniLazioListPage, meta: { title: "Elenco Prenotazione Recup" } },
];

export default routes;
